import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import './ItemList.css';

class ItemList extends Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  createItems() {
    // sort by priority if available
    let items = Object.keys(this.props.itemList).map((idx) => {
      const values = this.props.itemList[idx];
      values['idx'] = idx;
      return values;
    }).sort((a, b) => {
      return b['priority'] - a['priority'];
    });
    return items.map((values) => {
      const getAbstract = function(values) {
        if(values['abstract']){
          return <p>{values['abstract']}</p>
        }
        return null;
      };
      const url = "/" + this.props.view + "/" + values['id'];
      return <li key={values['idx']}>
        <Link to={url}>{values['title']}</Link>
        {getAbstract(values)}
      </li>;
    });
  }



  render() {
    if(!this.props.itemList){
      return null;
    }
    else{
      return <div>
        <h2>{this.props.itemHeadline}</h2>
        <ul className="itemlist ">{this.createItems()}</ul>
      </div>
    }

  }
}

export default ItemList;




// WEBPACK FOOTER //
// ./src/components/ItemList.js